/**
 * Design system da página de vendas (PV) · comportamento
 * - Selo de desconto ao lado do preço, recalculado quando o cliente troca de variante.
 * - Vídeos verticais: tocar abre o vídeo com som e controles; só um toca por vez.
 * Carregado como módulo: executa uma única vez por página.
 */

const config = () => document.querySelector('pv-ds-config');

const digits = (el) => {
  if (!el) return 0;
  const n = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
  return Number.isFinite(n) ? n : 0;
};

function updateBadge(priceEl) {
  const container = priceEl.querySelector('[ref="priceContainer"]');
  if (!container) return;
  const template = config()?.dataset.badge;
  const current = container.querySelector(':scope > .price bdi, :scope > .price');
  const compare = container.querySelector(':scope > .compare-at-price bdi, :scope > .compare-at-price');
  let badge = container.querySelector(':scope > .pv-badge');

  const price = digits(current);
  const was = digits(compare);
  const show = template && compare && was > price && price > 0;

  if (!show) {
    if (badge) badge.remove();
    return;
  }

  const pct = Math.round(((was - price) / was) * 100);
  const text = template.replace('[pct]', String(pct));
  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'pv-badge';
    container.append(badge);
  }
  if (badge.textContent !== text) badge.textContent = text;
}

const watched = new WeakSet();

function setupPrices(root = document) {
  root.querySelectorAll('.product-details product-price').forEach((priceEl) => {
    updateBadge(priceEl);
    if (watched.has(priceEl)) return;
    watched.add(priceEl);
    let frame = 0;
    new MutationObserver(() => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        updateBadge(priceEl);
      });
    }).observe(priceEl, { childList: true, subtree: true, characterData: true });
  });
}

function stopOthers(except) {
  document.querySelectorAll('.pv-vcard.is-playing video').forEach((v) => {
    if (v === except) return;
    v.pause();
  });
}

if (!window.__pvDsInit) {
  window.__pvDsInit = true;

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.pv-vcard__play') : null;
    if (!button) return;
    const card = button.closest('.pv-vcard');
    const video = card?.querySelector('video');
    if (!video) return;
    stopOthers(video);
    video.muted = false;
    video.controls = true;
    card.classList.add('is-playing');
    video.play().catch(() => {});
    video.addEventListener(
      'pause',
      () => {
        if (video.ended || video.paused) card.classList.remove('is-playing');
      },
      { once: true }
    );
  });

  document.addEventListener('shopify:section:load', (e) => setupPrices(e.target));
  document.addEventListener('shopify:block:select', () => setupPrices());
}

setupPrices();
